import React from "react";
import EditUserForm from "../components/admin/EditUserForm";

function EditUser() {
  document.title = "TicketBlaster | Edit";

  return <EditUserForm />;
}
export default EditUser;
